import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import Image from "next/image";
import styles from "./qr-section.module.css";
import { useViewport } from "@cinch-labs/shared-util";
import { TickIcon } from "@cinch-nx/design-system-icons";
export var QrCodeSection = function(param) {
    var sectionData = param.sectionData;
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var isDesktop = vw > 767;
    var title = sectionData.title, qr_code = sectionData.qr_code, disclaimer = sectionData.disclaimer, features_list = sectionData.features_list;
    var _alt, _alt1;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.wrapper,
        children: [
            isDesktop && /*#__PURE__*/ _jsxs("div", {
                className: styles.qrWrapper,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        element: "h2",
                        fontSize: "3xl",
                        className: styles.title,
                        children: title
                    }),
                    qr_code && /*#__PURE__*/ _jsx("div", {
                        "aria-label": (_alt = qr_code.alt) !== null && _alt !== void 0 ? _alt : "",
                        className: styles.qrImage,
                        children: /*#__PURE__*/ _jsx(Image, {
                            alt: (_alt1 = qr_code.alt) !== null && _alt1 !== void 0 ? _alt1 : "",
                            src: qr_code.filename,
                            height: 320,
                            width: 320,
                            layout: "responsive"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.disclaimer,
                        children: disclaimer
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.listWrapper,
                children: /*#__PURE__*/ _jsx("ul", {
                    className: styles.featureList,
                    "aria-label": "mobile app feature list",
                    children: features_list && features_list.filter(function(item) {
                        return item && item.feature;
                    }).map(function(item) {
                        return /*#__PURE__*/ _jsxs("li", {
                            "aria-label": item.feature,
                            className: styles.featureItem,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.featureIcon,
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: styles.icon,
                                        children: /*#__PURE__*/ _jsx(TickIcon, {
                                            size: 16
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    className: styles.featureText,
                                    children: item.feature
                                })
                            ]
                        }, item._uid);
                    })
                })
            })
        ]
    });
};
